import React, { useState } from 'react';
import { func, object } from 'prop-types';
import { MODALS } from 'constants/modals';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { get, isEmpty } from 'ravenjs/utils/lodash';
import ListItem from 'ravenjs/lib/ListItem';
import List from 'ravenjs/lib/List';
import Typography from 'ravenjs/lib/Typography';
import Box from 'ravenjs/lib/Box';
import Col from 'ravenjs/lib/Col';
import Row from 'ravenjs/lib/Row';
import { genID } from 'ravenjs/utils/generate';

import { actions as uiActions, selectors as uiSelectors } from 'modules/ui';
import { actions as userActions } from 'modules/user';

import YouTubeFrame from 'components/YouTubeFrame';
import Modal from '../Modal';

const ListItemStyled = styled(ListItem)`
    padding: 10px 0;
`;

function LivingHandbookModal(props) {
    const { closeModal, modal, triggerUserInterestInHandbookFeature } = props;
    const [showVideo, updateShowVideo] = useState(false);

    if (isEmpty(modal.data)) {
        return null;
    }

    const confirmButtonText = get(modal, 'data.actions.confirm_modal_text');
    const interestTrack = get(modal, 'data.interest', []);
    const listItems = get(modal, 'data.content.list_items', []);
    const title = get(modal, 'data.heading.title', 'Living Handbook');
    const videoId = get(modal, 'data.content.youtube_video_id');
    const uniqueIDs = listItems.map(() => genID());

    const renderVideoPlayer = () =>
        showVideo ? (
            <Row display="flex" justify="center">
                <YouTubeFrame title={title} videoId={videoId} autoplay />
            </Row>
        ) : null;

    const renderContent = () => {
        return (
            <>
                {renderVideoPlayer()}
                <Row>
                    <Col padding="0 20px 0 10px">
                        <Box height="250px" margin="0">
                            <img
                                src={get(modal, 'data.content.left_image')}
                                alt="living handbook"
                                height="100%"
                                width="100%"
                            />
                        </Box>
                    </Col>
                    <Col padding="0 10px 0 20px">
                        <List listStyle="disc">
                            {listItems.map(
                                ({ bold_text: boldText, item_text: itemText }, index) => (
                                    <ListItemStyled key={uniqueIDs[index]}>
                                        <Typography
                                            fontWeight="bold"
                                            type="span"
                                        >{`${boldText} - `}</Typography>
                                        <Typography type="span">{itemText}</Typography>
                                    </ListItemStyled>
                                )
                            )}
                        </List>
                    </Col>
                </Row>
            </>
        );
    };

    const actions = [
        {
            onClick() {
                updateShowVideo(true);
            },
            text: 'Demo',
            color: 'secondary',
        },
        {
            onClick() {
                triggerUserInterestInHandbookFeature({ interestTrack });
            },
            text: confirmButtonText.toUpperCase(),
            color: 'primary',
        },
        {
            onClick() {
                closeModal(MODALS.LIVING_HANDBOOK);
            },
            text: 'Close',
            color: 'cancelButton',
        },
    ];

    return (
        <Modal
            id={MODALS.LIVING_HANDBOOK}
            actions={actions}
            content={renderContent()}
            open={get(modal, 'open', false)}
        />
    );
}

LivingHandbookModal.propTypes = {
    closeModal: func.isRequired,
    modal: object.isRequired,
    triggerUserInterestInHandbookFeature: func.isRequired,
};

const mapStateToProps = createStructuredSelector({
    modal: uiSelectors.getModalById(MODALS.LIVING_HANDBOOK),
});

const mapDispatchToProps = {
    closeModal: uiActions.closeModal,
    triggerUserInterestInHandbookFeature: userActions.triggerUserInterestInHandbookFeature,
};

export default connect(mapStateToProps, mapDispatchToProps)(LivingHandbookModal);
